export default "<img alt=\"{{el.text}}\" src=\"{{el.image_url}}\"  />";